import React from 'react'
import { Grid } from '@material-ui/core'
import { tableStatusBtns } from './const'
import AsterButton from 'asterX-UI/Buttons/AsterButton'
import { useStyles } from './spp-wl-table.styles'
import clsx from 'clsx'
import { CloseIcon } from 'asterX-UI/Icons'
import CheckIcon from '@material-ui/icons/Check'
import AsterChip from 'asterX-UI/DataDisplay/AsterChip'
import { colorStatusesByCode } from 'constants/deals'
import StandardTable from 'asterX-UI/Table/StandardTable'
import { ERROR_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import { useRoutes } from 'hooks'
import { DEAL_VIEW_PATH, HOME_PATH } from 'routes/constants.routes'
import { Pagination } from '@material-ui/lab'
import { useHomeStoreSpp } from 'context/HomeStore/SPP'

export const SppWLTable = () => {
  const classes = useStyles()
  const router = useRoutes()

  const {
    homeStore: { wlCount, wlList, wlTab, pagination },
    homeStoreFunc: { onPaginationChange, setWlTab }
  } = useHomeStoreSpp()

  const columns = [
    'id',
    'Номер РЛ',
    'Имя',
    'VIN-код',
    'Тип создания',
    'Подвод',
    'Трейд-ин',
    'Новый контракт',
    'Сотрудник',
    'Статус'
  ]

  const rows = wlList
    ? wlList?.map(e => {
        return [
          e.id,
          e.globalId,
          [e.client.firstName, e.client.lastName].join(' '),
          e.selectedCarsForSale?.length
            ? e.selectedCarsForSale.map(e => e?.vin || '').join(', ')
            : '',
          e.creationType,
          !!e?.carst ? (
            <CheckIcon
              style={{
                color: SUCCESS_COLORS[700],
                fontSize: 10
              }}
            />
          ) : (
            <CloseIcon style={{ color: ERROR_COLORS[700], width: 10 }} />
          ),
          !!e?.creditRequest ? (
            <CheckIcon
              style={{
                color: SUCCESS_COLORS[700],
                fontSize: 10
              }}
            />
          ) : (
            <CloseIcon style={{ color: ERROR_COLORS[700], width: 10 }} />
          ),
          !!e?.isRedirect ? (
            <CheckIcon
              style={{
                color: SUCCESS_COLORS[700],
                fontSize: 10
              }}
            />
          ) : (
            <CloseIcon style={{ color: ERROR_COLORS[700], width: 10 }} />
          ),
          e.assignToFullName ? (
            e.assignToFullName
          ) : (
            <p style={{ color: ERROR_COLORS[500] }}>Нет менеджера</p>
          ),
          <AsterChip
            label={e?.saleStatus?.name || 'Активный'}
            style={{
              ...colorStatusesByCode(e?.saleStatus?.code)
            }}
          />
        ]
      })
    : []

  return (
    <Grid item container>
      <Grid item container className={classes.wlTable}>
        <Grid item container className={classes.filterTabs}>
          {tableStatusBtns.map((e, i) => {
            const isActive = wlTab === i

            return (
              <Grid key={`table_status_btn_${i}`} item>
                <AsterButton
                  className={clsx(
                    classes.tableStatusBtn,
                    isActive ? classes.tableStatusBtnActive : ''
                  )}
                  onClick={() => setWlTab(i)}
                >
                  {e.label}

                  {isActive && (
                    <div className={classes.tableStatusCount}>
                      {wlCount || 0}
                    </div>
                  )}
                </AsterButton>
              </Grid>
            )
          })}
        </Grid>

        <Grid item container>
          <StandardTable
            tableData={{
              names: columns,
              rows
            }}
            onRowClick={row =>
              router.goTo(`${HOME_PATH}${DEAL_VIEW_PATH}/${row[0]}`)
            }
            tableStyles={{
              borderRadius: 0,
              boxShadow: 'none'
            }}
          />
        </Grid>
        <Grid item container style={{ padding: '12px 24px' }}>
          <Pagination
            variant="outlined"
            shape="rounded"
            size="large"
            className={classes.pagination}
            count={pagination.count}
            page={pagination.offset ? pagination.offset : 1}
            onChange={onPaginationChange}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
